import { useEffect, useState } from "react";
import { Company } from "../types";

let _companies: Company[] = [];
let observers: React.Dispatch<React.SetStateAction<Company[]>>[] = [];

const setCompanies = (companies: Company[]): void => {
    _companies = companies;
    observers.forEach((update) => update(_companies));
};

export const useCompanies = (): [Company[], (companies: Company[]) => void] => {
    const [companiesState, setCompaniesState] = useState<Company[]>(_companies);

    useEffect(() => {
        observers.push(setCompaniesState);

        setCompaniesState(_companies);

        return () => {
            observers = observers.filter(
                (update) => update !== setCompaniesState
            );
        };
    }, []);

    return [companiesState, setCompanies];
};
